export const formatPhoneNumber = (value: string) => {
  const formattedPattern = /^\(\d{3}\)\d{3}-\d{4}$/

  if (formattedPattern.test(value)) {
    return value
  }

  if (value.length === 0) {
    return ""
  } else if (value.length <= 3) {
    return `(${value}`
  } else if (value.length <= 6) {
    return `(${value.slice(0, 3)})${value.slice(3)}`
  } else {
    return `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`
  }
}
